export function getEscapedStr (text) {
  return text.split('@')
    .map(str => `{'${str}'}`)
    .join('{\'@\'}')
}

export function getEscapedRoles (roles) {
  return roles.map(role => ({
    ...role,
    objectives: role.objectives.map(objective => ({
      ...objective,
      keyResults: objective.keyResults.map(keyResult => getEscapedStr(keyResult))
    }))
  }))
}
